// thx arco.design
const target = typeof window === "undefined" ? globalThis : window;
const vendors = ["webkit", "ms", "moz", "o"];
let raf = target.requestAnimationFrame;
let caf = target.cancelAnimationFrame;
if (!raf || !caf) {
    vendors.some((prefix) => {
        raf = target[`${prefix}RequestAnimationFrame`];
        caf =
            target[`${prefix}CancelAnimationFrame`] ||
                target[`${prefix}CancelRequestAnimationFrame`];
        return raf && caf;
    });
    if (!raf || !caf) {
        let lastTime = 0;
        raf = function (cb) {
            const currentTime = Date.now();
            const diff = Math.max(0, 16 - (currentTime - lastTime));
            const timer = setTimeout(() => {
                cb();
                lastTime = currentTime + diff;
            }, diff);
            return timer;
        };
        caf = function (timer) {
            clearTimeout(timer);
        };
    }
}
raf = raf.bind(target);
caf = caf.bind(target);
export { raf, caf };
//# sourceMappingURL=raf.js.map